import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandHoldingDollar } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const StyledWalletLinkSectionContainer = styled.section`
  width: 55px;
  height: 100%;
  margin: 0;
  padding: 0;
  border-left: 1px solid #e5e5e5;
  position: relative;
  @media (max-width: 600px) {
    position: static;
  }
`;

const StyledWalletLinkIconContainer = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    transition: all 0.3s ease;

    svg {
      font-size: 22px;
      color: #707070;
      transition: all 0.3s ease;
    }

    &:hover,
    &.active {
      background-color: ${({ theme }) =>
    theme.colors.secondaryColor || "#0078ce"};
      border-radius: 8px;

      svg {
        color: #fff !important; // ensures icon stays visible
      }
    }
  }
`;

const WalletDepositCreateLink = () => {
  return (
    <StyledWalletLinkSectionContainer>
      <StyledWalletLinkIconContainer>
        <Link
          to="/accounting/wallet-deposit-requests/create"
          title="Create Wallet Deposit"
        >
          <FontAwesomeIcon icon={faHandHoldingDollar} />
        </Link>
      </StyledWalletLinkIconContainer>
    </StyledWalletLinkSectionContainer>
  );
};

export default WalletDepositCreateLink;
